<template>
    <div class="zanzibar">
        <v-container grid-list-xs>
            <h1>Zanzibar</h1>
            <p>The Zanzibar Archipelago, located in the Indian Ocean 30 km off the coast of Tanzania, is a breathtaking spot to escape from the world. On its main island Unguja, familiarly called Zanzibar, lies Stone Town, an historic trade center with swahili and islamic influences. Its winding lanes present minarets, carved doorways and 19th century landmarks such as the House of Wonders, a former sultan palace. The northern villages of Nungwi and Kendwa have wide beaches lined with hotels.</p>
            <v-layout row wrap>
                <v-flex v-for="(tour, index) in tours" :key="tour.id" xs12 md6 xl3 pa-2>
                    <v-card class="mx-auto" @click="$router.push({name: 'Details', params:{ id:tour.id, tourProp:tours[index] }})" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                        <v-img
                        height="200px"
                        :src="require(`../../public/img/img/destination_${tour.image}.jpg`)"
                        aspect-ratio="2.75"
                        ></v-img>
                        <v-card-title v-text="tour.title"></v-card-title>
                        <v-card-subtitle v-text="tour.duration"></v-card-subtitle>
                        

                        <v-card-actions>
                        <v-btn ripple
                          text
                          color="deep-purple accent-4"
                        >
                          Read
                        </v-btn>
                        <!-- <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-share-variant</v-icon>
                        </v-btn> -->
                      </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import firebase from '../configFirebase.js'
export default {
    name: 'Zanzibar',
    data(){
        return{
            tours:[]
        }
    },
    mounted(){
    firebase.db.collection('travels').onSnapshot((snapShot) => {
            this.tours=[];
            snapShot.forEach((tour)  => {
                if(tour.data().kind==="zanzibar")
                    this.tours.push({
                        id:tour.id,
                        title:tour.data().title,
                        duration:tour.data().duration,
                        image:tour.data().image,
                        kind:tour.data().kind,
                        description:tour.data().description
                })
            });
        });
    }
}
</script>